module.exports = __webpack_public_path__ + "static/img/r-4-2.e09296a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/r-4-2.png
// module id = RLog
// module chunks = 0